import Vue from 'vue'
import App from './App.vue'
import VueAgile from 'vue-agile'
import router from './router'
import store from './store'
import i18n from './i18n'
import helpers from '@/helpers'
import config from './config'

import VueLazyload from 'vue-lazyload'
import CKEditor from '@ckeditor/ckeditor5-vue'
import Vuelidate from 'vuelidate'
import VueScrollTo from 'vue-scrollto'
import VueKanban from 'vue-kanban'
import VTooltip from 'v-tooltip'
// import VueFileAgent from 'vue-file-agent'

import CustomDateFilter from '@/filters/custom-date'
import JoinArrayFilter from '@/filters/join-array'
import JoinFieldsFilter from '@/filters/join-fields'

import './components/_base/_globals'
import fontAwesome from './font-awesome'
import { testId } from './directives'
import 'nprogress/nprogress.css'

import NotificationBar from './components/_shared/notification-bar/NotificationBar.vue'

import moment from 'moment-timezone'

fontAwesome(Vue)
testId(Vue)

Vue.use(VueAgile)
Vue.use(CustomDateFilter)
Vue.use(JoinArrayFilter)
Vue.use(JoinFieldsFilter)

Vue.use(VueLazyload, {
  loading: '/img/loading.gif',
  error: '/img/placeholder_img.png',
  attempt: 1
})
Vue.use(CKEditor)
Vue.use(Vuelidate)
Vue.use(VueScrollTo, config.scrollToOptions)
Vue.use(VueKanban)
Vue.use(VTooltip)
// Vue.use(VueFileAgent)

i18n.locale = 'en'

Vue.config.productionTip = false

const notification = new Vue(NotificationBar).$mount()
Vue.prototype.$notification = notification
document.body.appendChild(notification.$el)

new Vue({
  router,
  store,
  i18n,
  created () {
    helpers.validateAutoLogin()
  },
  render: h => h(App)
}).$mount('#app')

helpers.printCopyright()
